import React from 'react';
import { EyeIcon } from '@heroicons/react/20/solid';
import {
    DropdownMenuSub,
    DropdownMenuSubTrigger,
    DropdownMenuSubContent,
    DropdownMenuCheckboxItem,
} from 'components/shadcn/ui/dropdown-menu';

const ShowLinesSubmenu = ({ lines, showLines, setShowLines, disabled }) => {
    const toggleLines = (line) => {
        if (showLines.includes(line)) {
            setShowLines(showLines.filter((l) => l !== line));
        } else {
            setShowLines([...showLines, line]);
        }
    };

    return (
        <DropdownMenuSub>
            <DropdownMenuSubTrigger
                className="focus:bg-slate-100 focus:text-accent-foreground data-[disabled]:pointer-events-none data-[state=open]:bg-slate-100 data-[disabled]:opacity-50"
                disabled={disabled}
                arrowLeft
            >
                <EyeIcon />
                <span>Show Lines</span>
            </DropdownMenuSubTrigger>
            <DropdownMenuSubContent>
                {lines.map((line, index) => (
                    <DropdownMenuCheckboxItem
                        key={index}
                        checked={showLines.includes(line)}
                        onCheckedChange={() => toggleLines(line)}
                        onSelect={(e) => e.preventDefault()}
                    >
                        {line}
                    </DropdownMenuCheckboxItem>
                ))}
            </DropdownMenuSubContent>
        </DropdownMenuSub>
    );
};

export default ShowLinesSubmenu;
